export const catalogQueryKeys = {
  departments: (universeId: number, season: string) => ['useDepartments', universeId, season] as const,
  departmentPic: (ids: number[]) => ['useDepartmentPic', ids] as const,
  family: (subdepartmentId: number, season: string) => ['family', subdepartmentId, season] as const,
  subdepartments: (universeId: number, departmentId: number, season: string) => ['useSubdepartments', universeId, departmentId, season] as const,
  universePic: (ids: number[]) => ['useUniversePic', ids] as const,
  universes: (season: string) => ['useUniverses', season] as const,
}
